import Section from "../../common/section";
import {
  getTitleClass,
  getThemeClass,
  getSectionPaddingClass,
} from "~/styles/styles";
import CustomButton from "../../common/button";
import PhoneCircleIcon from "../../icon/phone";
import {
  INCLUSO_HUBSPOT_DISCOVERY_CALENDAR,
  INCLUSO_PHONE,
} from "~/content/value";
import { forwardRef, type LegacyRef } from "react";

type BookingSectionProps = {
  theme?: string;
  title?: string | JSX.Element;
  titleColour?: string;
  body?: string;
  afterAction?: JSX.Element;
  center?: boolean;
  customCols?: string;
  textLeft?: boolean;
};

const BookDiscovery = (props: BookingSectionProps, ref: LegacyRef<HTMLElement> | undefined) => {
  const button = (
    <CustomButton
      size="sm-long"
      className="mx-auto w-fit flex-col xs:min-w-[12rem] md:mx-0"
      tel
      href={INCLUSO_PHONE}
      nogap
    >
      <p className="text-sm">or call us now</p>
      <p className="flex items-center gap-1 text-lg leading-6">
        <PhoneCircleIcon className="size-5" /> 1300 674 401
      </p>
    </CustomButton>
  );

  return (
    <Section
      id="book"
      className={`${getThemeClass("light")} ${getSectionPaddingClass("sm")}`}
      ref={ref}
    >
      <div
        className={`mx-auto max-w-[32rem] md:flex md:max-w-7xl ml:gap-6 2xl:gap-0`}
      >
        <div
          className={`md:w-2/5 lg:w-4/12 xl:w-3/12 ${props.textLeft ?? "order-last"}`}
        >
          <div className={`TEXTs`}>
            <h2
              className={`font-bold text-purpleblue md:pt-4 ${getTitleClass("base")} `}
            >
              Book a <span className="md:block">Discovery Call</span>
            </h2>

            <div className={`mb-4 mt-1 text-sm md:mt-4 lg:text-base`}>
              Book a discovery call with us to learn more about our services and
              how we can help you.
            </div>
          </div>

          <div className="mt-6 hidden md:block">{button}</div>
        </div>

        <iframe
          //md:w-3/5 lg:w-8/12 xl:w-9/12
          className="CALENDAR mx-auto h-[760px] w-full md:mx-0 xl:w-9/12"
          src={INCLUSO_HUBSPOT_DISCOVERY_CALENDAR}
        />

        <div className="mt-6 md:hidden">{button}</div>
      </div>
    </Section>
  );
};

export default forwardRef(BookDiscovery);
